// this section is for temporary use during the Viva Engage rebranding. It will be removed post-rebrand.
import { YammerExperimentsState } from '../../state/types';

export const getTreatments = (state: YammerExperimentsState) => state.ecsExperiments.treatments;

export const isVivaEngageRebrandFlightEnabled = (state: YammerExperimentsState): boolean => {
  const treatments = getTreatments(state);

  return treatments.VivaEngageRebranding === true;
};
